import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IApiResponse } from '../modelo/PageProps';
import { Processamento } from '../modelo/Processamento';
import { Observable } from 'rxjs';
import { ProcessamentoLista } from '../modelo/ProcessamentoLista';

@Injectable({
  providedIn: 'root'
})
export class ProcessamentoService {
  apiUrl: string = `${environment.backendUrl}/processamento`;

  constructor(private http: HttpClient) { }

  uploadFile(file: File, processamento: Processamento){
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/arquivos/${processamento.uuid}`,formData, { observe: 'response', responseType: 'text' });
  }

  listar() {
    return this.http.get<IApiResponse>(`${this.apiUrl}`);
  }

  listarArquivos(processamento: Processamento) {
    return this.http.get<IApiResponse>(`${this.apiUrl}/arquivos/${processamento.uuid}`);
  }

  listarErros(processamento: Processamento) {
    return this.http.get<IApiResponse>(`${this.apiUrl}/tipoerros/${processamento.uuid}`);
  }

  salvar(processamento: Processamento): Observable<any> {
    return this.http.post(`${this.apiUrl}`, processamento);
  }

  salvarArquivo(processamentoLista: ProcessamentoLista) {
    return this.http.post(`${this.apiUrl}/arquivos/salvar/${processamentoLista.id}`, processamentoLista);
  }

  excluirArquivo(processamentoLista: ProcessamentoLista) {
    return this.http.delete(`${this.apiUrl}/arquivos/${processamentoLista.id}`);
  }

  solicitaProcessamento(processamento: Processamento) {
    return this.http.put(`${this.apiUrl}/inicia/${processamento.uuid}`, null);
  }

  solicitaCancelamento(processamento: Processamento) {
    return this.http.put(`${this.apiUrl}/cancelar/${processamento.uuid}`, null);
  }

  exportar(processamento: Processamento, apenasErros: boolean): Observable<Blob> {
    return this.http.post<any>(`${this.apiUrl}/exportacao/${processamento.uuid}/${apenasErros}`, null,
    { responseType: 'blob' as 'json' });
  }

  statusProtocolo(processamento: Processamento): Observable<Blob> {
    return this.http.post<any>(`${this.apiUrl}/protocolos/${processamento.uuid}`, null,
    { responseType: 'blob' as 'json' });
  }
}
